// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"d708f9d1","239":"bdd945ae","453":"1d17f2dd","455":"1e2bd891","977":"c5d82167"}[chunkId] + ".chunk.js";
};